import { AdvisorCallout } from './AdvisorCallout'
import { Disclaimer } from './Disclaimer'
import { HighEarnersArticle } from './HighEarnersArticle'
import { OnTrackCalculator, type OnTrackCalculatorProps } from './OnTrackCalculator'

export function OnTrackPageContent(calculatorProps: OnTrackCalculatorProps) {
  return (
    <main className="min-h-screen bg-background pb-28 tablet:pb-20">
      <section className="mx-auto grid max-w-300 grid-cols-1 gap-4 px-4 pt-8 pb-6 tablet:grid-cols-12 tablet:items-end tablet:gap-8 tablet:px-8 tablet:pt-14 tablet:pb-10">
        <h1 className="text-title-xl text-charcoal tablet:col-span-7">
          <span className="mb-3 block text-body-xs font-bold text-green-dark uppercase">Retirement Calculator</span>{' '}
          <span className="block">
            Are you on track for <em className="text-green-dark italic">financial independence?</em>
          </span>
        </h1>
        <p className="text-body-sm text-neutral-darker tablet:col-span-5 tablet:pb-2">
          Even in your prime earning years, it&apos;s easy to feel like you&apos;re falling behind. But until you
          actually run the numbers, it&apos;s hard to know if that&apos;s true. Enter a few details to estimate where
          you stand, and — if there is a gap — how much you need to close it.
        </p>
      </section>

      <OnTrackCalculator {...calculatorProps} />

      <div className="mt-14 tablet:mt-28">
        <HighEarnersArticle />
      </div>

      <div className="mx-auto mt-10 max-w-300 px-4 tablet:mt-16 tablet:px-8">
        <AdvisorCallout />
      </div>

      <div className="mx-auto mt-10 max-w-300 px-4 tablet:px-8">
        <Disclaimer />
      </div>
    </main>
  )
}
